import styled from 'styled-components'

export const Button = styled.button`
  align-items: center;
  background-color: #EB5A00;
  border: none;
  border-radius: 40px;
  box-shadow: 0px 0px 25px 0px #DA652900;
  color: #FFF;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  font-size: 1.125rem;
  font-weight: 600;
  gap: 8px;
  outline: none;
  padding: 16px 32px;
  text-align: center;

  &.transparent {
    background-color: transparent;
    border: 1px solid #1D1D1D;
    color: #1D1D1D;
  }

  &:disabled {
    opacity: 0.6;
  }
`
